import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';

// images
import appStoreImg from '../../assets/images/app-store.png';
import googlePlayImg from '../../assets/images/google-play.png';
import {
  currentBrandSelector,
  mobileAppLinksSelector
} from '../../helpers/selectors';
import { connect } from 'react-redux';

export class MobileBanner extends Component {
  constructor(props) {
    super(props);
    this.bindFunctions();
  }

  bindFunctions() {
    this.handleAppStoreClick = this.handleAppStoreClick.bind(this);
    this.handlePlayStoreClick = this.handlePlayStoreClick.bind(this);
  }

  handleAppStoreClick() {
    window.open(this.props.mobileAppLinks.appStoreLink, '_blank');
  }

  handlePlayStoreClick() {
    window.open(this.props.mobileAppLinks.playStoreLink, '_blank');
  }

  render() {
    const { currentBrand, mobileAppLinks, productName } = this.props;
    const { mobileBannerImage } = currentBrand || {};
    const { playStoreLink, appStoreLink } = mobileAppLinks;

    return (
      <div className="background-bg-dark" style={{ minHeight: '2px' }}>
        {(playStoreLink || appStoreLink) && (
          <div className="mobile-banner">
            {mobileBannerImage && (
              <div className="phone-image-container">
                <img alt="phone" className="phone-image" src={mobileBannerImage} />
              </div>
            )}
            <div className="download-app">
              <p className="title pt-15 pb-15 f-32 f-xs-26">
                <FormattedMessage id="mobile_banner.text" values={{ productName }} />
              </p>
              {appStoreLink && (
                 <img
                  src={appStoreImg}
                  alt="App Store"
                  className="mobile-store-img"
                  onClick={this.handleAppStoreClick}
                  style={{ cursor: 'pointer' }}
                />
              )}
              {playStoreLink && (
                <img
                  src={googlePlayImg}
                  alt="Google Play"
                  className="mobile-store-img ml-10"
                  onClick={this.handlePlayStoreClick}
                  style={{ cursor: 'pointer' }}
                />
              )}
            </div>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    currentBrand: currentBrandSelector(state),
    mobileAppLinks: mobileAppLinksSelector(state)
  };
};

export default connect(mapStateToProps)(MobileBanner);
